// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import articleCategoryEntity from './entities/article-category.json';
import articleCategoryMenu from '../pages/article-category/menu.json';
import articleCategoryFullForm from '../pages/article-category/forms/full.json';
import articleCategoryContextForm from '../pages/article-category/forms/context.json';
import articleCategoryMiniForm from '../pages/article-category/forms/mini.json';
import articleCategoryLookupForm from '../pages/article-category/forms/lookup.json';
import articleCategoryTableView from '../pages/article-category/views/table.json';
import articleCategoryDashboardView from '../pages/article-category/views/dashboard.json';

/** Тип запису «Категорія статті» зі сторінками пакета: меню, форми та подання з pages/article-category/. */
export const articleCategoryDefinition: IRecordTypeDefinition = {
  ...articleCategoryEntity,
  views: assembleViewSet({
      table: articleCategoryTableView,
      dashboard: articleCategoryDashboardView,
  }),
  form: articleCategoryFullForm,
  forms: { full: articleCategoryFullForm, context: articleCategoryContextForm, mini: articleCategoryMiniForm, lookup: articleCategoryLookupForm },
  menu: articleCategoryMenu,
} as IRecordTypeDefinition;
